<template>
    <div>
      <br /><br />
      <a-table :columns="columns" :data-source="data">
        <a slot="action" slot-scope="text,record"  @click="handleEdit(record.name)">编辑</a>
      </a-table>  
    </div>
  </template>
  <script>
  const columns = [
          {
            title: '型号',
            dataIndex: 'name',
            scopedSlots: { customRender: 'name' },
          },{
            title: '版本',
            dataIndex: 'version',
            scopedSlots: { customRender: 'version' },
          },
          {
            title: '编辑',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
          },
        ];
  
  
  
  export default {
    data() {
      
      let versionlist;
      this.$axios({
        method:'post',
        url:'/api/version/list',
        
      }).then((response) =>{          //这里使用了ES6的语法
         this.data = response.data
         this.Showpage = true
         console.log(response)       //请求成功返回的数据
      }).catch((error) =>{
           console.log(error)       //请求失败返回的数据       
      })
      return {
        Showpage:false,
        data:versionlist,
        columns
      };
    },
    methods:{
      handleEdit(key){
        this.$store.state.productname = key;
        this.$router.push('/home/newproduct');
      },
      handleAdd() {
        this.$router.push('/home/newproduct');
      }
      
    },
  };
  </script>
  


// WEBPACK FOOTER //
// src/components/VersionList.vue